// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssv-root,
.ssv-root * {
  box-sizing: border-box;
}

.ssv-root * {
  margin: 0;
  padding: 0;
}

.ssv-root .ssv-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.ssv-root {
  --bg-deep: #0b0a1f;
  --bg-mid: #16143a;
  --violet: #9d7bff;
  --cyan: #4fd8c4;
  --pink: #ff6fb0;
  --ink: #f4f2ff;
  --ink-dim: rgba(244, 242, 255, 0.62);
  --ink-faint: rgba(244, 242, 255, 0.4);
  position: relative;
  min-height: 100vh;
  background:
    radial-gradient(ellipse 120% 80% at 20% -10%, #241f5c 0%, transparent 55%),
    radial-gradient(ellipse 100% 70% at 100% 0%, #2a1440 0%, transparent 50%),
    linear-gradient(180deg, var(--bg-deep) 0%, #0d0c24 55%, #0a0918 100%);
  color: var(--ink);
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
  overflow-x: hidden;
}

.ssv-root h1,
.ssv-root h2,
.ssv-root h3 {
  font-family: "Space Grotesk", ui-sans-serif, system-ui, sans-serif;
}

.ssv-starfield {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

/* Nav */
.ssv-topbar {
  position: sticky;
  top: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px clamp(16px, 4vw, 48px);
  background: rgba(11, 10, 31, 0.55);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.ssv-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 15px;
}

.ssv-logo-mark {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--violet), var(--pink));
  box-shadow: 0 0 18px rgba(157, 123, 255, 0.55);
}

.ssv-nav {
  display: flex;
  align-items: center;
  gap: 28px;
}

.ssv-nav a {
  color: var(--ink-dim);
  text-decoration: none;
  font-size: 14px;
  transition: color 200ms;
}

.ssv-nav a:hover {
  color: var(--ink);
}

.ssv-clock {
  display: none;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--ink-faint);
}

.ssv-clock-divider {
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.2);
}

.ssv-topbar-right {
  display: flex;
  align-items: center;
  gap: 18px;
}

.ssv-cta-small {
  background: var(--ink);
  color: #0b0a1f;
  border: none;
  border-radius: 999px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 150ms ease;
}

.ssv-cta-small:hover {
  transform: translateY(-1px);
}

.ssv-menu-btn {
  display: none;
  background: none;
  border: none;
  color: var(--ink);
  cursor: pointer;
}

.ssv-mobile-menu {
  position: relative;
  z-index: 39;
  background: rgba(11, 10, 31, 0.96);
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.ssv-mobile-menu a {
  color: var(--ink);
  text-decoration: none;
}

/* Stationary Hero Container */
.ssv-hero {
  position: relative;
  padding: 40px clamp(16px, 6vw, 64px) 10px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  background: transparent;
  border: none;
  height: 77vh;
}

@media (min-width: 960px) {
  .ssv-hero {
    grid-template-columns: 0.9fr 1.1fr;
    align-items: center;
  }
}

.ssv-hero-copy {
  max-width: 640px;
}

.ssv-eyebrow-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
}

.ssv-version-pill {
  font-size: 12px;
  color: var(--ink-dim);
  border: 1px solid rgba(255, 255, 255, 0.16);
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
}

.ssv-hero h1 {
  font-size: clamp(2.4rem, 5.5vw, 4.2rem);
  line-height: 1.04;
  font-weight: 600;
  letter-spacing: -0.02em;
  margin: 0 0 22px;
}

.ssv-hero-sub {
  font-size: clamp(1rem, 1.5vw, 1.18rem);
  color: var(--ink-dim);
  line-height: 1.6;
  max-width: 52ch;
  margin: 0 0 32px;
}

.ssv-hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.ssv-btn-primary {
  background: linear-gradient(135deg, var(--violet), var(--pink));
  color: #0b0a1f;
  font-weight: 600;
  font-size: 15px;
  border: none;
  padding: 13px 26px;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 12px 30px -8px rgba(157, 123, 255, 0.55);
}

.ssv-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--ink);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.14);
  padding: 12px 22px;
  border-radius: 999px;
}

/* Draggable Hero Window Stage Area */
.ssv-stage {
  position: relative;
  min-height: 550px;
  width: 100%;
}

.ssv-hero-window {
  position: absolute;
  width: 210px;
  background: rgba(22, 20, 58, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  backdrop-filter: blur(20px);
  box-shadow: 0 30px 60px -20px rgba(0, 0, 0, 0.65);
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  z-index: 10;
}

.ssv-hero-window--lg {
  width: 250px;
}

.ssv-hero-window-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.25);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.ssv-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.ssv-dot--r {
  background: #ff5f57;
}
.ssv-dot--y {
  background: #febc2e;
}
.ssv-dot--g {
  background: #28c840;
}

.ssv-hero-window-title {
  margin-left: 6px;
  font-size: 11px;
  color: var(--ink-faint);
  flex: 1 1;
}

.ssv-window-drag-icon {
  color: var(--ink-faint);
  opacity: 0.6;
}

.ssv-hero-window-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ssv-hero-window-tagline {
  font-size: 12px;
  color: var(--ink-dim);
}

/* MacBook Floating Dock Section */
.ssv-dock-wrapper {
  position: relative;
  z-index: 35;
  padding: 25px;
  display: flex;
  justify-content: center;
  overflow: visible;
}

.ssv-dock {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 26px;
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  max-width: 90vw;
  overflow: visible !important;
}
@media (max-width: 768px) {
  .ssv-dock {
    overflow-x: auto !important;
  }
}
.ssv-dock-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
  position: relative;
  color: var(--ink);
  text-decoration: none;
  transform-origin: bottom center;
}

/* macOS Floating Tooltip Title Fix */
.ssv-dock-label {
  position: absolute;
  top: -38px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  background: rgba(11, 10, 31, 0.95);
  color: var(--ink);
  padding: 5px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  opacity: 0;
  pointer-events: none;
  transition:
    opacity 150ms ease,
    transform 150ms ease;
  z-index: 200;
}

.ssv-dock-item:hover .ssv-dock-label {
  opacity: 1;
}

/* Sections & App Cards */
.ssv-section {
  position: relative;
  z-index: 1;
  padding: 64px clamp(16px, 6vw, 64px);
  scroll-margin-top: 84px;
}

.ssv-social-section,
.ssv-cta-panel {
  scroll-margin-top: 84px;
}

.ssv-section-head {
  max-width: 620px;
  margin-bottom: 40px;
}

.ssv-section-head h2 {
  font-size: clamp(1.7rem, 3.2vw, 2.4rem);
  font-weight: 600;
  letter-spacing: -0.01em;
  margin: 0 0 12px;
}

.ssv-section-head p {
  color: var(--ink-dim);
  font-size: 1rem;
  line-height: 1.6;
}

.ssv-app-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.ssv-app-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  transition:
    background 200ms ease,
    border-color 200ms ease,
    box-shadow 200ms ease;
  cursor: pointer;
}

.ssv-app-card:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: var(--accent);
  box-shadow: 0 12px 30px -10px var(--accent);
}

.ssv-app-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  margin-bottom: 16px;
  color: var(--accent);
}

.ssv-app-category {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ink-faint);
  margin-bottom: 6px;
}

.ssv-app-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--accent);
}

.ssv-app-tagline {
  font-size: 13px;
  color: var(--ink);
  font-weight: 500;
  margin-bottom: 12px;
}

.ssv-app-desc {
  font-size: 13.5px;
  color: var(--ink-dim);
  line-height: 1.5;
}

/* Pillars & Stats */
.ssv-pillars {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
  margin-bottom: 56px;
}

.ssv-pillar {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: 24px;
}

.ssv-pillar-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.ssv-pillar h3 {
  font-size: 1.1rem;
  margin-bottom: 8px;
}

.ssv-pillar p {
  color: var(--ink-dim);
  font-size: 14px;
  line-height: 1.5;
}

.ssv-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 40px;
}

.ssv-stat-value {
  font-size: clamp(2rem, 3.5vw, 2.8rem);
  font-weight: 700;
  background: linear-gradient(135deg, var(--violet), var(--cyan));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ssv-stat-label {
  font-size: 13px;
  color: var(--ink-dim);
}

/* Social Community */
.ssv-social-section {
  position: relative;
  z-index: 1;
  padding: 24px clamp(16px, 6vw, 64px) 64px;
}

.ssv-section-kicker {
  display: inline-block;
  margin-bottom: 12px;
  color: var(--cyan);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.ssv-social-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}

.ssv-social-card {
  --social-accent: var(--violet);
  min-height: 220px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  color: var(--ink);
  text-decoration: none;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 16px;
  transition:
    transform 180ms ease,
    background 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease;
}

.ssv-social-card[data-accent="cyan"] {
  --social-accent: var(--cyan);
}

.ssv-social-card[data-accent="pink"] {
  --social-accent: var(--pink);
}

.ssv-social-card:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.07);
  border-color: var(--social-accent);
  box-shadow: 0 16px 34px -18px var(--social-accent);
}

.ssv-social-card-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  color: var(--social-accent);
  background: color-mix(in srgb, var(--social-accent) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--social-accent) 38%, transparent);
  border-radius: 12px;
}

.ssv-social-card-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ssv-social-card-name {
  font-family: "Space Grotesk", ui-sans-serif, system-ui, sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
}

.ssv-social-card-topline svg {
  color: var(--social-accent);
}

.ssv-social-card-handle {
  margin-top: 4px;
  color: var(--social-accent);
  font-size: 12px;
  font-weight: 600;
}

.ssv-social-card-description {
  margin-top: auto;
  padding-top: 22px;
  color: var(--ink-dim);
  font-size: 13px;
  line-height: 1.5;
}

/* CTA Waitlist Form */
.ssv-cta-panel {
  margin: 0 clamp(16px, 6vw, 64px) 64px;
  background: linear-gradient(
    135deg,
    rgba(157, 123, 255, 0.12),
    rgba(255, 111, 176, 0.12)
  );
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 28px;
  padding: clamp(32px, 5vw, 56px);
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  align-items: center;
}

@media (min-width: 840px) {
  .ssv-cta-panel {
    grid-template-columns: 1fr 1fr;
  }
}

.ssv-cta-panel h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  margin-bottom: 12px;
}

.ssv-cta-panel p {
  color: var(--ink-dim);
  line-height: 1.5;
}

.ssv-cta-form {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.ssv-cta-form input {
  flex: 1 1;
  min-width: 220px;
  background: rgba(11, 10, 31, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 999px;
  padding: 13px 20px;
  color: var(--ink);
  font-size: 14px;
  outline: none;
}

.ssv-cta-form input:focus {
  border-color: var(--violet);
}

/* Footer */
.ssv-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 32px clamp(16px, 6vw, 64px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 13px;
  color: var(--ink-faint);
}

.ssv-footer-links {
  display: flex;
  gap: 20px;
}

.ssv-footer-links a,
.ssv-footer-social a {
  color: var(--ink-dim);
  text-decoration: none;
}

.ssv-footer-social {
  display: flex;
  align-items: center;
  gap: 14px;
}

@media (min-width: 720px) {
  .ssv-clock {
    display: flex;
  }
}

@media (max-width: 720px) {
  .ssv-nav {
    display: none;
  }
  .ssv-menu-btn {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB;;;yEAGuE;EACvE,iBAAiB;EACjB,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;;;EAGE,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2CAA2C;EAC3C,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,+DAA+D;EAC/D,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,iDAAiD;EACjD,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;EAClD,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,yCAAyC;EACzC,UAAU;EACV,oBAAoB;EACpB;;wBAEsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;;;yBAGuB;EACvB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;EACnB;;;;yBAIuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,qEAAqE;EACrE,2EAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kEAAkE;EAClE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC;;;;GAIC;EACD,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,+CAA+C;EAC/C,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap\");\n\n.ssv-root,\n.ssv-root * {\n  box-sizing: border-box;\n}\n\n.ssv-root * {\n  margin: 0;\n  padding: 0;\n}\n\n.ssv-root .ssv-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.ssv-root {\n  --bg-deep: #0b0a1f;\n  --bg-mid: #16143a;\n  --violet: #9d7bff;\n  --cyan: #4fd8c4;\n  --pink: #ff6fb0;\n  --ink: #f4f2ff;\n  --ink-dim: rgba(244, 242, 255, 0.62);\n  --ink-faint: rgba(244, 242, 255, 0.4);\n  position: relative;\n  min-height: 100vh;\n  background:\n    radial-gradient(ellipse 120% 80% at 20% -10%, #241f5c 0%, transparent 55%),\n    radial-gradient(ellipse 100% 70% at 100% 0%, #2a1440 0%, transparent 50%),\n    linear-gradient(180deg, var(--bg-deep) 0%, #0d0c24 55%, #0a0918 100%);\n  color: var(--ink);\n  font-family: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  overflow-x: hidden;\n}\n\n.ssv-root h1,\n.ssv-root h2,\n.ssv-root h3 {\n  font-family: \"Space Grotesk\", ui-sans-serif, system-ui, sans-serif;\n}\n\n.ssv-starfield {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* Nav */\n.ssv-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px clamp(16px, 4vw, 48px);\n  background: rgba(11, 10, 31, 0.55);\n  backdrop-filter: blur(18px) saturate(140%);\n  -webkit-backdrop-filter: blur(18px) saturate(140%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.ssv-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.ssv-logo-mark {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, var(--violet), var(--pink));\n  box-shadow: 0 0 18px rgba(157, 123, 255, 0.55);\n}\n\n.ssv-nav {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n}\n\n.ssv-nav a {\n  color: var(--ink-dim);\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 200ms;\n}\n\n.ssv-nav a:hover {\n  color: var(--ink);\n}\n\n.ssv-clock {\n  display: none;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--ink-faint);\n}\n\n.ssv-clock-divider {\n  width: 1px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.ssv-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.ssv-cta-small {\n  background: var(--ink);\n  color: #0b0a1f;\n  border: none;\n  border-radius: 999px;\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 150ms ease;\n}\n\n.ssv-cta-small:hover {\n  transform: translateY(-1px);\n}\n\n.ssv-menu-btn {\n  display: none;\n  background: none;\n  border: none;\n  color: var(--ink);\n  cursor: pointer;\n}\n\n.ssv-mobile-menu {\n  position: relative;\n  z-index: 39;\n  background: rgba(11, 10, 31, 0.96);\n  padding: 16px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.ssv-mobile-menu a {\n  color: var(--ink);\n  text-decoration: none;\n}\n\n/* Stationary Hero Container */\n.ssv-hero {\n  position: relative;\n  padding: 40px clamp(16px, 6vw, 64px) 10px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  background: transparent;\n  border: none;\n  height: 77vh;\n}\n\n@media (min-width: 960px) {\n  .ssv-hero {\n    grid-template-columns: 0.9fr 1.1fr;\n    align-items: center;\n  }\n}\n\n.ssv-hero-copy {\n  max-width: 640px;\n}\n\n.ssv-eyebrow-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 22px;\n}\n\n.ssv-version-pill {\n  font-size: 12px;\n  color: var(--ink-dim);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.ssv-hero h1 {\n  font-size: clamp(2.4rem, 5.5vw, 4.2rem);\n  line-height: 1.04;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  margin: 0 0 22px;\n}\n\n.ssv-hero-sub {\n  font-size: clamp(1rem, 1.5vw, 1.18rem);\n  color: var(--ink-dim);\n  line-height: 1.6;\n  max-width: 52ch;\n  margin: 0 0 32px;\n}\n\n.ssv-hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.ssv-btn-primary {\n  background: linear-gradient(135deg, var(--violet), var(--pink));\n  color: #0b0a1f;\n  font-weight: 600;\n  font-size: 15px;\n  border: none;\n  padding: 13px 26px;\n  border-radius: 999px;\n  cursor: pointer;\n  box-shadow: 0 12px 30px -8px rgba(157, 123, 255, 0.55);\n}\n\n.ssv-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--ink);\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  padding: 12px 22px;\n  border-radius: 999px;\n}\n\n/* Draggable Hero Window Stage Area */\n.ssv-stage {\n  position: relative;\n  min-height: 550px;\n  width: 100%;\n}\n\n.ssv-hero-window {\n  position: absolute;\n  width: 210px;\n  background: rgba(22, 20, 58, 0.82);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 16px;\n  backdrop-filter: blur(20px);\n  box-shadow: 0 30px 60px -20px rgba(0, 0, 0, 0.65);\n  cursor: grab;\n  user-select: none;\n  z-index: 10;\n}\n\n.ssv-hero-window--lg {\n  width: 250px;\n}\n\n.ssv-hero-window-bar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(0, 0, 0, 0.25);\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.ssv-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n.ssv-dot--r {\n  background: #ff5f57;\n}\n.ssv-dot--y {\n  background: #febc2e;\n}\n.ssv-dot--g {\n  background: #28c840;\n}\n\n.ssv-hero-window-title {\n  margin-left: 6px;\n  font-size: 11px;\n  color: var(--ink-faint);\n  flex: 1;\n}\n\n.ssv-window-drag-icon {\n  color: var(--ink-faint);\n  opacity: 0.6;\n}\n\n.ssv-hero-window-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ssv-hero-window-tagline {\n  font-size: 12px;\n  color: var(--ink-dim);\n}\n\n/* MacBook Floating Dock Section */\n.ssv-dock-wrapper {\n  position: relative;\n  z-index: 35;\n  padding: 25px;\n  display: flex;\n  justify-content: center;\n  overflow: visible;\n}\n\n.ssv-dock {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 26px;\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  max-width: 90vw;\n  overflow: visible !important;\n}\n@media (max-width: 768px) {\n  .ssv-dock {\n    overflow-x: auto !important;\n  }\n}\n.ssv-dock-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  flex-shrink: 0;\n  position: relative;\n  color: var(--ink);\n  text-decoration: none;\n  transform-origin: bottom center;\n}\n\n/* macOS Floating Tooltip Title Fix */\n.ssv-dock-label {\n  position: absolute;\n  top: -38px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  background: rgba(11, 10, 31, 0.95);\n  color: var(--ink);\n  padding: 5px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    opacity 150ms ease,\n    transform 150ms ease;\n  z-index: 200;\n}\n\n.ssv-dock-item:hover .ssv-dock-label {\n  opacity: 1;\n}\n\n/* Sections & App Cards */\n.ssv-section {\n  position: relative;\n  z-index: 1;\n  padding: 64px clamp(16px, 6vw, 64px);\n  scroll-margin-top: 84px;\n}\n\n.ssv-social-section,\n.ssv-cta-panel {\n  scroll-margin-top: 84px;\n}\n\n.ssv-section-head {\n  max-width: 620px;\n  margin-bottom: 40px;\n}\n\n.ssv-section-head h2 {\n  font-size: clamp(1.7rem, 3.2vw, 2.4rem);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin: 0 0 12px;\n}\n\n.ssv-section-head p {\n  color: var(--ink-dim);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.ssv-app-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.ssv-app-card {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  transition:\n    background 200ms ease,\n    border-color 200ms ease,\n    box-shadow 200ms ease;\n  cursor: pointer;\n}\n\n.ssv-app-card:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: var(--accent);\n  box-shadow: 0 12px 30px -10px var(--accent);\n}\n\n.ssv-app-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.06);\n  margin-bottom: 16px;\n  color: var(--accent);\n}\n\n.ssv-app-category {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--ink-faint);\n  margin-bottom: 6px;\n}\n\n.ssv-app-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: var(--accent);\n}\n\n.ssv-app-tagline {\n  font-size: 13px;\n  color: var(--ink);\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.ssv-app-desc {\n  font-size: 13.5px;\n  color: var(--ink-dim);\n  line-height: 1.5;\n}\n\n/* Pillars & Stats */\n.ssv-pillars {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 24px;\n  margin-bottom: 56px;\n}\n\n.ssv-pillar {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  padding: 24px;\n}\n\n.ssv-pillar-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.ssv-pillar h3 {\n  font-size: 1.1rem;\n  margin-bottom: 8px;\n}\n\n.ssv-pillar p {\n  color: var(--ink-dim);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.ssv-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 40px;\n}\n\n.ssv-stat-value {\n  font-size: clamp(2rem, 3.5vw, 2.8rem);\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--violet), var(--cyan));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.ssv-stat-label {\n  font-size: 13px;\n  color: var(--ink-dim);\n}\n\n/* Social Community */\n.ssv-social-section {\n  position: relative;\n  z-index: 1;\n  padding: 24px clamp(16px, 6vw, 64px) 64px;\n}\n\n.ssv-section-kicker {\n  display: inline-block;\n  margin-bottom: 12px;\n  color: var(--cyan);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.ssv-social-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 14px;\n}\n\n.ssv-social-card {\n  --social-accent: var(--violet);\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  color: var(--ink);\n  text-decoration: none;\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 16px;\n  transition:\n    transform 180ms ease,\n    background 180ms ease,\n    border-color 180ms ease,\n    box-shadow 180ms ease;\n}\n\n.ssv-social-card[data-accent=\"cyan\"] {\n  --social-accent: var(--cyan);\n}\n\n.ssv-social-card[data-accent=\"pink\"] {\n  --social-accent: var(--pink);\n}\n\n.ssv-social-card:hover {\n  transform: translateY(-4px);\n  background: rgba(255, 255, 255, 0.07);\n  border-color: var(--social-accent);\n  box-shadow: 0 16px 34px -18px var(--social-accent);\n}\n\n.ssv-social-card-icon {\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 28px;\n  color: var(--social-accent);\n  background: color-mix(in srgb, var(--social-accent) 14%, transparent);\n  border: 1px solid color-mix(in srgb, var(--social-accent) 38%, transparent);\n  border-radius: 12px;\n}\n\n.ssv-social-card-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ssv-social-card-name {\n  font-family: \"Space Grotesk\", ui-sans-serif, system-ui, sans-serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.ssv-social-card-topline svg {\n  color: var(--social-accent);\n}\n\n.ssv-social-card-handle {\n  margin-top: 4px;\n  color: var(--social-accent);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ssv-social-card-description {\n  margin-top: auto;\n  padding-top: 22px;\n  color: var(--ink-dim);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* CTA Waitlist Form */\n.ssv-cta-panel {\n  margin: 0 clamp(16px, 6vw, 64px) 64px;\n  background: linear-gradient(\n    135deg,\n    rgba(157, 123, 255, 0.12),\n    rgba(255, 111, 176, 0.12)\n  );\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 28px;\n  padding: clamp(32px, 5vw, 56px);\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n  align-items: center;\n}\n\n@media (min-width: 840px) {\n  .ssv-cta-panel {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.ssv-cta-panel h2 {\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\n  margin-bottom: 12px;\n}\n\n.ssv-cta-panel p {\n  color: var(--ink-dim);\n  line-height: 1.5;\n}\n\n.ssv-cta-form {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.ssv-cta-form input {\n  flex: 1;\n  min-width: 220px;\n  background: rgba(11, 10, 31, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 999px;\n  padding: 13px 20px;\n  color: var(--ink);\n  font-size: 14px;\n  outline: none;\n}\n\n.ssv-cta-form input:focus {\n  border-color: var(--violet);\n}\n\n/* Footer */\n.ssv-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 32px clamp(16px, 6vw, 64px);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 13px;\n  color: var(--ink-faint);\n}\n\n.ssv-footer-links {\n  display: flex;\n  gap: 20px;\n}\n\n.ssv-footer-links a,\n.ssv-footer-social a {\n  color: var(--ink-dim);\n  text-decoration: none;\n}\n\n.ssv-footer-social {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n@media (min-width: 720px) {\n  .ssv-clock {\n    display: flex;\n  }\n}\n\n@media (max-width: 720px) {\n  .ssv-nav {\n    display: none;\n  }\n  .ssv-menu-btn {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
